import { render } from "./CarouselSimple.vue?vue&type=template&id=43638f07"
import script from "./CarouselSimple.vue?vue&type=script&lang=js"
export * from "./CarouselSimple.vue?vue&type=script&lang=js"
script.render = render

export default script